import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
    import ActivixDate from '@/value-objects/ActivixDate.js';
    import TimeZone from '@/components/timezone/TimeZone.ts';

    export interface TimeZoneDifferenceWarningProps {
        startTime: string;
        endTime?: string;
        timeZone?: string;
        city?: string;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TimeZoneDifferenceWarning',
  props: {
    startTime: null,
    endTime: { default: '' },
    timeZone: null,
    city: { default: '' }
  },
  setup(__props: any) {

const props = __props as { startTime: string, endTime: string, timeZone?: string, city: string }

    

    const isDanger = computed<boolean>(() => !props.timeZone);

    const iconName = computed<string>(() => (isDanger.value ? 'regular/alert-triangle' : 'regular/network-clock'));

    const formattedDuration = computed<string>(() => {
        if (isDanger.value) {
            return '';
        }

        const startAt = new ActivixDate(props.startTime, 'dateTime', props.timeZone);

        if (!props.endTime) {
            return startAt.toHumanTime();
        }

        const endAt = new ActivixDate(props.endTime, 'dateTime', props.timeZone);
        const sameDay = startAt.isSameDay(endAt);

        let formattedTimeDuration = sameDay ? startAt.toHumanTime() : startAt.toHumanShort();

        if (endAt.isAfter(startAt)) {
            formattedTimeDuration += sameDay
                ? ` - ${endAt.toHumanTime()}`
                : ` - ${endAt.toHumanShort()}`;
        }

        return formattedTimeDuration;
    });

    const formattedTimezone = computed<string>(() => {
        if (isDanger.value) {
            return '';
        }

        const timeZoneStandardizedName = TimeZone.standardizedName(props.timeZone);
        const timeZoneOffset = TimeZone.offset(props.timeZone);

        return props.city
            ? `${timeZoneStandardizedName}, ${props.city} (UTC${timeZoneOffset})`
            : `${timeZoneStandardizedName} (UTC${timeZoneOffset})`;
    });

return { __sfc: true,props, isDanger, iconName, formattedDuration, formattedTimezone }
}

})